<template>
  <div>
    <a-tabs v-model="tabNumber" defaultActiveKey="1" class="air-tabs-bordered">
      <a-tab-pane tab="Dagoverzicht" key="1" v-if="$auth.check('driver')" />
      <a-tab-pane tab="Totaal Overzicht" key="2" v-if="$auth.check('admin')" />
<!--      <a-tab-pane key="3">-->
<!--        <a-dropdown slot="tab" placement="bottomRight" :trigger="['click']">-->
<!--          <a-->
<!--            class="nav-link dropdown-toggle"-->
<!--            href="javascript: void(0);"-->
<!--            role="button"-->
<!--          >-->
<!--            Dropdown-->
<!--          </a>-->
<!--          <a-menu slot="overlay">-->
<!--            <a-menu-item>-->
<!--              <a href="javascript:;">Action</a>-->
<!--            </a-menu-item>-->
<!--            <a-menu-item>-->
<!--              <a href="javascript:;">Another action</a>-->
<!--            </a-menu-item>-->
<!--            <a-menu-item>-->
<!--              <a href="javascript:;">Something else here</a>-->
<!--            </a-menu-item>-->
<!--            <a-menu-divider />-->
<!--            <a-menu-item>-->
<!--              <a href="javascript:;">Separated link</a>-->
<!--            </a-menu-item>-->
<!--          </a-menu>-->
<!--        </a-dropdown>-->
<!--      </a-tab-pane>-->
    </a-tabs>
    <div class="air__utils__scrollTable mb-4 p-0" v-if="tabNumber === '1'">
      <div class="my-2 row">
        <div class="col-md-3 my-2">
          <a-button icon="left" @click="dayBefore()"></a-button>
          <a-date-picker v-model="date" :key="date.unix()" class="mx-2" :defaultValue="date" format="DD-MM-YYYY"/>
          <a-button icon="right" @click="dayAfter()"></a-button>
        </div>
        <div class="col-md-6 my-2">
          <a-dropdown placement="bottomCenter">
          <a-menu slot="overlay">
            <a-menu-item :class="service.done ? 'service--afgehandeld': ''"  v-bind:key="`serviceList-${key}`" v-for="service, key in serviceList">
               <div class="d-flex">
                  <div class="d-flex flex-column mx-2" style="width: 100px">
                    <p class="mb-0">#{{service.reservation.reserveringsnummer}}</p>
                    <p class="mb-0">{{service.reservation.vehicle_make_model.length > 10? service.reservation.vehicle_make_model.substring(0,10)+'...' : service.reservation.vehicle_make_model}}</p>
                  </div>
                  <div class="d-flex flex-column mx-2" style="width: 100px">
                    <p class="mb-0">{{service.reservation.first_name.substring(0,1)}} {{service.reservation.last_name.length > 8? service.reservation.last_name.substring(0,8)+'...' : service.reservation.last_name}}</p>
                    <p class="mb-0">{{service.reservation.license_plate}}</p>
                  </div>
                  <div class="d-flex flex-column mx-2" style="width: 100px">
                    <p class="mb-0">{{service.title}}</p>
                    <p class="mb-0">{{moment(service.reservation.arrival_time).locale("nl").fromNow()}}</p>
                  </div>
                  <div class="d-flex flex-column mx-2 justify-content-center" style="width: 100px">

                    <a-badge dot v-if="(moment(service.reservation.arrival_time).diff(moment(), 'days') < 2)">
                      <a-button v-if="!service.done" @click="markServiceAsDone(service, true)">Voltooid</a-button>
                      <a-button v-if="service.done" @click="markServiceAsDone(service, false)">Onvoltooid</a-button>
                    </a-badge>
                    <div v-else>
                      <a-button v-if="!service.done" @click="markServiceAsDone(service, true)">Voltooid</a-button>
                      <a-button v-if="service.done" @click="markServiceAsDone(service, false)">Onvoltooid</a-button>
                    </div>
                  </div>
               </div>
            </a-menu-item>
          </a-menu>
          <a-badge :count="serviceList.filter(service=>{ if( (moment(service.reservation.arrival_time).diff(moment(), 'days') < 2) ) { return service} }).filter(service=>{return !service.done}).length">
            <a-button style="margin-left: 8px"> Services <a-icon type="down" /> </a-button>
          </a-badge>
        </a-dropdown>

          <a-badge :count="serviceList.filter(service=>{ if( !(moment(service.reservation.arrival_time).diff(moment(), 'days') < 2) ) { return service} }).filter(service=>{return !service.done}).length" :number-style="{ backgroundColor: '#fdcb6e' }">
            <div class="h-100" style="padding-bottom: 21px; width: 25px;"></div>
          </a-badge>
          <a-button class="ml-3" type="primary" @click="streamContractsByDate()">Genereer contracten</a-button>
        </div>

        <div class="d-flex my-2 col-md-3 justify-content-end">
            <div class="mx-1" v-if="aannameAmount">
              <a-tag color="green">
                Aannames
              </a-tag>
              {{aannameAmount}}
            </div>
            <div class="mx-1" v-if="afleveringAmount">
              <a-tag color="orange">
                Afleveringen
              </a-tag>
              {{afleveringAmount}}
            </div>
            <div class="mx-1" v-if="data && $auth.check('admin')">
              <a-tag color="blue">
                Totaal
              </a-tag>
              {{data.filter(reservation => {return !reservation.cancelled}).filter(reservation=>{return reservation.display_type === 'aanname'}).reduce((a, b) => a + (parseFloat(b.rate) || 0), 0) | currency}}
            </div>
        </div>
      </div>
      <a-table
      v-if="data.length >0"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :rowClassName="(record, index) => ((record.afgeleverd && record.display_type === 'aflevering') || (record.aangenomen && record.display_type === 'aanname')) ? '' : (record.cancelled == true) ? 'reservation--cancelled' :  (record.display_type === 'aanname') ? 'reservation--aanname' : (record.display_type === 'aflevering')  ? 'reservation--aflevering' : ''"
        :locale="{emptyText: 'Geen reserveringen'}"
        rowKey="id"
      >
        <!--        <template slot="avatar" slot-scope="link">-->
        <!--          <div class="air__utils__avatar">-->
        <!--            <img :src="link" alt="User" />-->
        <!--          </div>-->
        <!--        </template>-->
        <template slot="reserveringsnummer" slot-scope="data">
            <div class="d-flex flex-column">
              <div>
                #{{data.reserveringsnummer}}
              </div>
              <div class="d-flex align-items-center">
                <div>
                  <div v-if="data.organization_id && data.payment_method === 'factuur'">
                    {{parseOrganizationName(data)}}
                  </div>
                  <div :class="((data.payment_method === 'ideal' && data.payment_status !== 'paid') || (data.payment_method === 'creditcard' && data.payment_status !== 'paid')) ? 'text-danger' : ''" v-else-if="data.payment_method">
                    {{capitalizeFirstLetter(data.payment_method)}}
                  </div>
                </div>
                <div class="ml-2">
                  <reservation-service-icons :services="data.extra" :display_type="data.display_type" />
                </div>
              </div>
            </div>
        </template>
        <template slot="fullname" slot-scope="data">
          <div class="d-flex flex-column">
            <div>{{data.fullname}}</div>
            <div><a :href="`tel:${data.phone_number}`">{{data.phone_number}}</a></div>
          </div>
        </template>
        <template slot="vehicle_make_model" slot-scope="data">
          <div class="d-flex flex-column">
            <div>{{data.vehicle_make_model.length > 20 ? data.vehicle_make_model.substring(0,20)+'...' : data.vehicle_make_model}}</div>
            <div>{{data.license_plate.toUpperCase()}} {{data.vehicle_color}}</div>
          </div>
        </template>
        <template slot="departure_arrival" slot-scope="data">
          <div class="d-flex flex-column">
            <div v-if="(data.display_type === 'aanname')">{{moment(data.departure_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm')}}</div>
            <div v-if="(data.display_type === 'aflevering')">{{moment(data.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm')}}</div>
            <div class="d-flex">
              <div v-if="(data.display_type === 'aanname')">{{data.departure_flightnumber}}</div>
              <div v-if="(data.display_type === 'aflevering')">{{data.arrival_flightnumber}}</div>
              <div class="ml-2" v-if="getSchipholDataLength(data)">
                <a-tag v-if="data.display_type ==='aflevering'" @click="openSchipholModal(data)" color="#c0392b">
                  {{getSchipholLabel(data).time !== null ? moment(getSchipholLabel(data).time).format('HH:mm') : getSchipholLabel(data).message}}
                </a-tag>
                <a-tag v-if="data.display_type ==='aanname'" @click="openSchipholModal(data)" color="#c0392b">
                  {{ getDepartureSchipholLabel(data).message }}
                </a-tag>
              </div>
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="data">
          <div class="d-flex">
            <a-radio-group class="d-flex flex-column" v-if="(data.display_type === 'aanname')" v-model="data.aangenomen" @change="aangenomenRadioChange(data)">
              <a-radio :style="radioStyle" :value="1">
                Ja
              </a-radio>
              <a-radio :style="radioStyle" :value="0">
                Nee
              </a-radio>
            </a-radio-group>
            <a-radio-group class="d-flex flex-column" v-if="(data.display_type === 'aflevering')" v-model="data.afgeleverd" @change="afgeleverdRadioChange(data)">
              <a-radio :style="radioStyle" :value="1">
                Ja
              </a-radio>
              <a-radio :style="radioStyle" :value="0">
                Nee
              </a-radio>
            </a-radio-group>
            <!-- <a-button @click="aangenomenPopup(data.id)" v-if="(data.display_type === 'aanname' && !data.aangenomen)" class="mr-3" type="primary">
                Aangenomen
            </a-button> -->
            <!-- <a-button @click="afgeleverdPopup(data.id)" v-if="(data.display_type === 'aflevering' && !data.afgeleverd)" class="mr-3" type="primary">
                Afgeleverd
            </a-button> -->
            <a-button @click="openReservation(data.id)" class="mr-3" type="primary">
                Bekijk
            </a-button>
            <!-- <button type="button" class="btn btn-primary mr-2">
              <i class="fe fe-plus-circle" />
            </button>
            <button type="button" class="btn btn-light">
              <i class="fe fe-edit text-blue" />
            </button> -->
          </div>
        </template>
      </a-table>
      <a-modal v-model="afgeleverdOrAangenomenPopup" :okText="(afgeleverdOrAangenomen.type  === 'aangenomen') ? 'Aangenomen':'Afgeleverd'" :title="`Reservering ${(afgeleverdOrAangenomen.type    === 'aangenomen') ? 'aangenomen' : 'afgeleverd'}`" @cancel="clearAfgeleverdOrAangenomen" @ok="handleAfgeleverdOrAangenomen">
        <p>Markeer reservering als {{afgeleverdOrAangenomen.type}}?</p>
      </a-modal>
    </div>
    <div class="air__utils__scrollTable mb-4 p-0" v-if="tabNumber === '2'">
      <reservations-all />
    </div>
    <a-modal v-model="schipholModalOpen" :footer="null" title="Schiphol Info">
      <div v-if="schipholModalSelectedReservationObject">
        <div class="mb-1" v-if="schipholModalSelectedReservationObject.fullname">
          <h5 class="input-label mb-1">Reservering</h5>
          <a-tag style="color: black;" :color="schipholModalSelectedReservationObject.display_type === 'aanname' ? '#1dd1a1' : schipholModalSelectedReservationObject.display_type === 'aflevering' ? '#ff9f43' : ''"> #{{schipholModalSelectedReservationObject.reserveringsnummer }}
          </a-tag>
          {{schipholModalSelectedReservationObject.fullname}}
        </div>
        <div class="mb-1" v-if="schipholModalSelectedReservationObject.vehicle_make_model">
          <h5 class="input-label">Naam</h5>
          {{schipholModalSelectedReservationObject.license_plate}} {{schipholModalSelectedReservationObject.vehicle_make_model}} {{schipholModalSelectedReservationObject.vehicle_color}}
        </div>
        <div class="mb-1">
          <h5 class="input-label">Vluchtnummer</h5>
          {{schipholModalObject.flightName}}
        </div>
      </div>
      <div v-if="schipholFlightDestinationObject">
        <div class="mb-1">
          <h5 class="input-label">{{schipholModalObject.flightDirection === 'D' ? 'Bestemming' : 'Oorsprong'}}</h5>
          {{schipholFlightDestinationObject.publicname_dutch || schipholFlightDestinationObject.publicname_english}}
        </div>
      </div>
      <div v-if="schipholModalObject">
        <div v-if="schipholModalObject.flightDirection === 'D'">
          <div class="mb-1" v-if="schipholModalObject.terminal">
            <h5 class="input-label">Terminal</h5>
            {{schipholModalObject.terminal}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.scheduleDateTime">
            <h5 class="input-label">Geplande Vertrektijd</h5>
            {{moment(schipholModalObject.scheduleDateTime).format('DD-MM-YYYY HH:mm')}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.expectedTimeGateOpen">
            <h5 class="input-label">Verwachte gate opening</h5>
            {{moment(schipholModalObject.expectedTimeGateOpen).format('DD-MM-YYYY HH:mm')}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.expectedTimeBoarding">
            <h5 class="input-label">Verwachte boardtijd</h5>
            {{moment(schipholModalObject.expectedTimeBoarding).format('DD-MM-YYYY HH:mm')}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.expectedTimeGateClosing">
            <h5 class="input-label">Verwachte gate sluiting</h5>
            {{moment(schipholModalObject.expectedTimeGateClosing).format('DD-MM-YYYY HH:mm')}}
          </div>

        </div>
        <div v-if="schipholModalObject.flightDirection === 'A'">
          <div class="mb-1" v-if="schipholModalObject.pier">
            <h5 class="input-label">Pier</h5>
            {{schipholModalObject.pier}}
          </div>
          <div>
            <h5 class="input-label">Vluchstatussen</h5>
            <div class="mb-1" v-if="schipholModalObject.publicFlightState.flightStates.length > 0">
              <div>
                <div v-for="flightState in schipholModalObject.publicFlightState.flightStates" class="d-flex">
                <div>
                  <a-tag class="mr-2" :color="checkIfCancelledOrTomorrow(parseFlightState(schipholModalObject.flightDirection, flightState).state) ? 'red' : 'blue'">
                    {{parseFlightState(schipholModalObject.flightDirection, flightState).message}}
                  </a-tag>
                  <span>{{parseFlightState(schipholModalObject.flightDirection, flightState).description}}</span>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="mb-1" v-if="schipholModalObject.scheduleDateTime">
            <h5 class="input-label">Geplande Landtijd</h5>
            {{moment(schipholModalObject.scheduleDateTime).format('DD-MM-YYYY HH:mm')}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.estimatedLandingTime">
            <h5 class="input-label">Verwachtte Landingstijd</h5>
            {{moment(schipholModalObject.estimatedLandingTime).format('DD-MM-YYYY HH:mm')}}
            <a-tag color="blue">
              {{Math.abs(Math.round(moment.duration(moment(schipholModalObject.estimatedLandingTime).diff(moment(schipholModalObject.scheduleDateTime))).asMinutes()))}}
              minuten
              <span v-if="Math.round(moment.duration(moment(schipholModalObject.estimatedLandingTime).diff(moment(schipholModalObject.scheduleDateTime))).asMinutes()) > 0">later </span>
              <span v-else>eerder </span>
            </a-tag>
          </div>
          <div class="mb-1" v-if="schipholModalObject.actualLandingTime">
            <h5 class="input-label">Werkelijke Landingstijd</h5>
            {{moment(schipholModalObject.actualLandingTime).format('DD-MM-YYYY HH:mm')}}
          </div>
          <div class="mb-1" v-if="schipholModalObject.expectedTimeOnBelt">
            <h5 class="input-label">Verwachtte Tijd Bagageband</h5>
            {{moment(schipholModalObject.expectedTimeOnBelt).format('DD-MM-YYYY HH:mm')}}
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import ReservationsAll from '@/components/widgets/Reservations/ReservationsAll'
import ReservationServiceIcons from './ReservationServiceIcons.vue'
const columns = [
  {
    title: 'Reserveringsnummer',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'reserveringsnummer' },
  },
  {
    title: 'Name',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'fullname' },
  },
  {
    title: 'Voertuig',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'vehicle_make_model' },
  },
  {
    title: 'Tijd',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'departure_arrival' },
  },
  {
    title: 'Afgehandeld',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'ReservationsDate',
  components: {
    ReservationsAll,
    ReservationServiceIcons,
  },
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data: function() {
    return {
      columns,
      data: [],
      serviceList: [],
      aannameAmount: undefined,
      afleveringAmount: undefined,
      totalIncome: undefined,
      tabNumber: '1',
      date: this.moment(this.moment().format('DD-MM-YYYY'), 'DD-MM-YYYY'),
      afgeleverdOrAangenomen: {},
      afgeleverdOrAangenomenPopup: false,
      radioStyle: {
        display: 'flex',
        height: '15px',
        lineHeight: '15px',
        marginLeft: '0px',
        marginBottom: '3px',
      },
      schipholModalOpen: false,
      schipholModalObject: undefined,
      schipholFlightDestinationObject: undefined,
      schipholModalSelectedReservationObject: undefined,
    }
  },
  mounted() {
    this.getReservationsByDate()
  },
  watch: {
    date(newVal) {
      if (newVal) {
        this.getReservationsByDate()
      }
    },
  },
  methods: {
    parseOrganizationName(data) {
      if (data.organization.name === null || data.organization.name === undefined) {
        return 'Lege bedrijfsnaam'
      }
      return data.organization.name.length > 10 ? data.organization.name.substring(0, 10) + '...' : data.organization.name
    },
    getSchipholDataLength(data) {
      let labelFlightInfo = data.flightinfo.filter(flightinfo => { return ((flightinfo.arrival_or_departure === 'D' && data.display_type === 'aanname') || (flightinfo.arrival_or_departure === 'A' && data.display_type === 'aflevering')) })
      if (labelFlightInfo.length > 0) {
        return true
      } else {
        return false
      }
    },
    openSchipholModal(data) {
      this.schipholFlightDestinationObject = undefined
      let labelFlightInfo = data.flightinfo.filter(flightinfo => { return ((flightinfo.arrival_or_departure === 'D' && data.display_type === 'aanname') || (flightinfo.arrival_or_departure === 'A' && data.display_type === 'aflevering')) })
      if (labelFlightInfo.length > 0) {
        labelFlightInfo = labelFlightInfo[0].json_data
        this.schipholModalSelectedReservationObject = data

        this.schipholModalObject = labelFlightInfo
        if (labelFlightInfo.route.destinations.length > 0) {
          this.$axios.get('flight-destination', { params: {
            iata: labelFlightInfo.route.destinations[0],
          },
          headers: {
            'Authorization': `Bearer ${this.user.user.token}`,
          } }).then(response => {
            this.schipholFlightDestinationObject = response.data
            this.schipholModalOpen = true
          }).catch(error => {
            this.schipholModalOpen = true
            console.log(error)
          })
        }
      }
    },
    checkIfCancelledOrTomorrow(state) {
      // return boolean

      if (state === 'CNX' || state === 'TOM') {
        return true
      } else {
        return false
      }
    },
    parseFlightState(direction, flightState) {
      const arrivalFlightStates = [
        { state: 'SCH', message: 'Schema', description: 'De vlucht is volgens schema' },
        { state: 'AIR', message: 'In de lucht', description: 'De vlucht is in de lucht' },
        { state: 'EXP', message: 'Verwacht', description: 'De landingstijd wijkt 10 of meer minuten af van de geplande tijd' },
        { state: 'LND', message: 'Geland', description: 'De vlucht is geland' },
        { state: 'FIB', message: 'Eerste bagage', description: 'De eerste bagage is bijna op de band' },
        { state: 'ARR', message: 'Aangekomen', description: 'De vlucht is aangekomen en afgehandeld' },
        { state: 'DIV', message: 'Gediverteerd', description: 'De vlucht is gediverteerd en land op een andere luchthaven' },
        { state: 'CNX', message: 'Geannuleerd', description: 'De vlucht is geannuleerd' },
        { state: 'TOM', message: 'Morgen', description: 'De vlucht is morgen' },
      ]
      const departureFlightStates = [
        { state: 'SCH', message: 'Schema', description: 'De vlucht is volgens schema' },
        { state: 'DEL', message: 'Vertraagd', description: 'De vlucht is vertraagd' },
        { state: 'WIL', message: 'Wachten in Lounge', description: 'De passagiers moeten wachten in de lounge' },
        { state: 'GTO', message: 'Gate Open', description: 'De gate is open voor passagiers' },
        { state: 'BRD', message: 'Boarding', description: 'Passagiers kunnen boarden' },
        { state: 'GCL', message: 'Gate Closing', description: 'De gate sluit' },
        { state: 'GTD', message: 'Gate Closed', description: 'De gate is gesloten' },
        { state: 'DEP', message: 'Vertrokken', description: 'De vlucht is vertrokken' },
        { state: 'CNX', message: 'Geannuleerd', description: 'De vlucht is geannuleerd' },
        { state: 'TOM', message: 'Morgen', description: 'De vlucht is morgen' },
      ]

      if (direction === 'A') {
        return arrivalFlightStates.filter(state => { return state.state === flightState })[0]
      }
      if (direction === 'D') {
        return departureFlightStates.filter(state => { return state.state === flightState })[0]
      }
    },
    getDepartureSchipholLabel(data) {
      let labelFlightInfo = data.flightinfo.filter(flightinfo => { return ((flightinfo.arrival_or_departure === 'D' && data.display_type === 'aanname') || (flightinfo.arrival_or_departure === 'A' && data.display_type === 'aflevering')) })
      if (labelFlightInfo.length > 0) {
        labelFlightInfo = labelFlightInfo[0].json_data
        // if publicFlightState.flightStates contains CNX
        if (labelFlightInfo.publicFlightState.flightStates.includes('CNX')) {
          return {
            type: 'cancelled',
            time: null,
            message: 'Geannuleerd',
          }
        }
        // if publicFlightState.flightStates contains TOM
        if (labelFlightInfo.publicFlightState.flightStates.includes('TOM')) {
          return {
            type: 'tomorrow',
            time: null,
            message: 'Morgen',
          }
        }
        return {
          type: 'scheduleDateTime',
          time: null,
          message: 'Info',

        }
      }
    },
    getSchipholLabel(data) {
      let labelFlightInfo = data.flightinfo.filter(flightinfo => { return ((flightinfo.arrival_or_departure === 'D' && data.display_type === 'aanname') || (flightinfo.arrival_or_departure === 'A' && data.display_type === 'aflevering')) })
      if (labelFlightInfo.length > 0) {
        labelFlightInfo = labelFlightInfo[0].json_data
        // if publicFlightState.flightStates contains CNX
        if (labelFlightInfo.publicFlightState.flightStates.includes('CNX')) {
          return {
            type: 'cancelled',
            time: null,
            message: 'Geannuleerd',
          }
        }
        // if publicFlightState.flightStates contains TOM
        if (labelFlightInfo.publicFlightState.flightStates.includes('TOM')) {
          return {
            type: 'tomorrow',
            time: null,
            message: 'Morgen',
          }
        }
        if (labelFlightInfo.estimatedLandingTime) {
          return {
            type: 'estimatedLandingTime',
            time: labelFlightInfo.estimatedLandingTime,
            message: 'Verwachte landing',
          }
        }
        if (labelFlightInfo.scheduleDateTime) {
          return {
            type: 'scheduleDateTime',
            time: labelFlightInfo.scheduleDateTime,
            message: 'Geplande tijd',
          }
        }
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    markServiceAsDone(data, status) {
      this.$axios.post('/reservation/extra/done', {
        extra_id: data.id,
        status,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getServiceList()
        this.$message.success('Servicestatus gewijzigd')
      })
    },
    aangenomenRadioChange(data) {
      this.$axios.post('/reservation/aangenomen', {
        reservation_id: data.id,
        status: data.aangenomen,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getReservationsByDate()
        this.afgeleverdOrAangenomenPopup = false
        this.$message.success('Aannamestatus gewijzigd')
      })
    },
    afgeleverdRadioChange(data) {
      this.$axios.post('/reservation/afgeleverd', {
        reservation_id: data.id,
        status: data.afgeleverd,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getReservationsByDate()
        this.afgeleverdOrAangenomenPopup = false
        this.$message.success('Afleveringstatus gewijzigd')
      })
    },
    dayBefore() {
      this.date = this.date.subtract(1, 'days')
      this.getReservationsByDate()
      this.$forceUpdate()
    },
    dayAfter() {
      this.date = this.date.add(1, 'days')
      this.getReservationsByDate()
      this.$forceUpdate()
    },

    aangenomenPopup(id) {
      this.afgeleverdOrAangenomen = {
        type: 'aangenomen',
        id,
      }
      this.afgeleverdOrAangenomenPopup = true
    },
    afgeleverdPopup(id) {
      this.afgeleverdOrAangenomen = {
        type: 'afgeleverd',
        id,
      }
      this.afgeleverdOrAangenomenPopup = true
    },
    clearAfgeleverdOrAangenomen() {
      this.afgeleverdOrAangenomen = {}
    },
    handleAfgeleverdOrAangenomen() {
      let url
      if (this.afgeleverdOrAangenomen.type === 'aangenomen') {
        url = '/reservation/aangenomen'
      }
      if (this.afgeleverdOrAangenomen.type === 'afgeleverd') {
        url = '/reservation/afgeleverd'
      }
      this.$axios.post(url, {
        reservation_id: this.afgeleverdOrAangenomen.id,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getReservationsByDate()
        this.afgeleverdOrAangenomenPopup = false
        this.$message.success('Reservering ' + this.afgeleverdOrAangenomen.type)
      })
    },
    openReservation(id) {
      this.$router.push({ name: 'singleReservation', params: { reservation_id: id } })
    },
    getServiceList() {
      this.$axios.get('/servicesByDate', { params: {
        date: this.date.unix(),
      },
      headers: {
        'Authorization': `Bearer ${this.user.user.token}`,
      } }).then(response => {
        this.serviceList = response.data.sort((firstItem, secondItem) => firstItem.arrival_time - secondItem.arrival_time)
      })
    },
    getReservationsByDate() {
      this.$axios.get('/reservationsByDate', { params: {
        date: this.date.unix(),
      },
      headers: {
        'Authorization': `Bearer ${this.user.user.token}`,
      } }).then(response => {
        this.data = response.data
        if (this.data.length > 0) {
          this.aannameAmount = response.data.filter(reservation => { return !reservation.cancelled }).filter(reservation => { return reservation.display_type === 'aanname' }).length
          this.afleveringAmount = response.data.filter(reservation => { return !reservation.cancelled }).filter(reservation => { return reservation.display_type === 'aflevering' }).length
          console.log(response.data.filter(reservation => { reservation.display_type === 'aflevering' }), response.data.filter(reservation => { reservation.display_type === 'aflevering' }).length)
        }
        this.getServiceList()
        //   this.$nextTick(() => {
        //     // Could've also used :rowClassName="(record, index) => (record.cancelled == true) ? 'cancelled' :  ''" in the table attributes
        //     response.data.forEach(reservation=>{
        //       if(reservation.cancelled === true){
        //         document.querySelectorAll(`[data-row-key='${reservation.id}']`)[0].classList.add("reservation--cancelled");
        //         return;
        //       }
        //       if(reservation.display_type === 'aflevering'){
        //         document.querySelectorAll(`[data-row-key='${reservation.id}']`)[0].classList.add("reservation--aflevering");
        //         return;
        //       }
        //       if(reservation.display_type === 'aanname'){
        //         document.querySelectorAll(`[data-row-key='${reservation.id}']`)[0].classList.add("reservation--aanname");
        //         return;
        //       }

        //   })
        // });
      })
    },
    streamContractsByDate() {
      this.$axios.get('/streamContractsByDate', { params: {
        date: this.date.unix(),
        print: true,
      },
      headers: {
        'Authorization': `Bearer ${this.user.user.token}`,
      } }).then(response => {
        let responseHtml = response.data
        var myWindow = window.open('', 'response', 'resizable=yes')
        myWindow.document.write(responseHtml)
      })
    },
  },
}
</script>
<style lang="scss">
.reservation--cancelled{
  background-color: lighten(grey, 20%);
}
.reservation--aflevering{
  background-color: lighten(#ff9f43, 20%);
}
.reservation--aanname{
  background-color: lighten(#1dd1a1, 20%);
}
.service--afgehandeld{
  background-color: darken(#f6ffed, 1%);
}
.service--spoed{
  background-color: #f6ffed;
}
.service--spoed{
    animation:blinkingText 3.2s  infinite;
    -webkit-transition: background-color 2000ms ease-in-out;
    -ms-transition: background-color 2000ms ease-in-out;
    transition: background-color 2000ms ease-in-out;

}
@keyframes blinkingText{
    0%{     background-color: #fff1f0;    }
    49%{    background-color: #fff1f0; }
    60%{    background-color: #fe948d; }
    99%{    background-color: #fe948d;  }
    100%{   background-color: #fff1f0;    }
}
</style>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

  .input-label{
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
</style>
